import React from 'react';
import Loadable from 'react-loadable';

import LoadingPage from '../misc/Loading';


const LiaisonDetailPageLoadableWrapper = Loadable({
  loader: () => import('./LiaisonDetailPage'),
  loading: LoadingPage
});

export default LiaisonDetailPageLoadableWrapper;


// WEBPACK FOOTER //
// ./src/components/pages/LiaisonDetailPageLoadable.jsx